import store from '../views/store';
import api from '../../static/config/api'

export const encoderSocket = (function () {
    let instance = null;//定义初始化_instance

    let Socket = function () {
        return new WebSocket('wss://127.0.0.1:12657');
    };
    return {
        getInstance: function () {
            if (!instance) {
                instance = new Socket();
            }
            return instance;
        },
        destroy: function () {
            if (instance) {
                instance.close();
                instance = null;
            }
        },
    };
})();

export function sdkInit(callback) {
    //process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';
    let socket = new encoderSocket.getInstance();
    let eeprom = '';
    let oneLineEEPROM = '';
    socket.onopen = function (event) {
        store.commit("SET_ENCODERNAME", 'SDK');
        store.commit("SET_ENCODERSTATUS", 'success');
        console.log('open');
        console.log(event);
        //initSdk();
    };
    socket.onmessage = function (event) {
        console.log('on message');
        console.log(event.data);
        // let content = '';
        // if(true == isJSON(event.data)) {
        //     console.log('isJson');
        //     var obj = JSON.parse(event.data);
        //     console.log(obj.data);       
        //     socket.publicKey = obj.data.code;
        //     console.log(socket.publicKey);
        //     content = event.data;
        // } else if(event.data.length < 16) {
        //     console.log('length < 16');
        //     content = event.data;
        // } else {
        //     console.log('else');
        //     console.log(socket.publicKey);
        //     let socketPublicKey = new NodeRSA(socket.publicKey, 'pkcs1-public');
        //     content = socketPublicKey.decryptPublic(event.data, 'utf8');
        // }
        // console.log(content);

        if(event.data == '@Closed')
        {
            store.commit("SET_ENCODERNAME", 'Encoder');
            store.commit("SET_ENCODERSTATUS", 'info');
        }
        else if(event.data == '@NFCEncoder')
        {
            store.commit("SET_ENCODERNAME", 'NFC Encoder');
            store.commit("SET_ENCODERSTATUS", 'warning');
        }
        else if(event.data == '@BLEEncoder')
        {
            store.commit("SET_ENCODERNAME", 'BLE Encoder');
            store.commit("SET_ENCODERSTATUS", 'warning');
        }
        else if(event.data == '@NFCKey')
        {
            store.commit("SET_ENCODERNAME", 'NFC Key');
            store.commit("SET_ENCODERSTATUS", 'success');
        }
        else if(event.data == '@BLEKey')
        {
            store.commit("SET_ENCODERNAME", 'BLE Key');
            store.commit("SET_ENCODERSTATUS", 'success');
        }
        else if(event.data.indexOf('@progress') > -1)
        {
            if(event.data.indexOf('@progress_readkeyeeprom') > -1)
            {
                let dataList = event.data.split('_');
                let progressList = dataList[2].split('/');
                if(parseInt(progressList[0]) === 0)
                {
                    store.commit("SET_KEYEEPROM", '');
                    eeprom = '';
                    oneLineEEPROM = '';
                }
                else
                {
                    oneLineEEPROM = oneLineEEPROM + dataList[3];
                    while(oneLineEEPROM.length >= 32)
                    {
                        eeprom = eeprom + oneLineEEPROM.substring(0, 32) + '\n';
                        oneLineEEPROM = oneLineEEPROM.substring(32, oneLineEEPROM.length);
                    }

                    if(parseInt(progressList[0]) === parseInt(progressList[1]))
                    {
                        if(oneLineEEPROM.length > 0)
                        {
                            eeprom = eeprom + oneLineEEPROM;
                        }
                        store.commit("SET_KEYEEPROM", eeprom);
                    }
                }
            }
        }
        else
        {
            
            //store.commit("SET_RESULT", JSON.parse(content));

            store.commit("SET_RESULT", JSON.parse(event.data));
        }
    };
    socket.onerror = function (event) {
        console.log('error');
        console.log(event);
    };
    socket.onclose = function (event) {
        store.commit("SET_ENCODERNAME", 'SDK');
        store.commit("SET_ENCODERSTATUS", 'info');
        console.log('close');
        console.log(event);
    }
}

export function isJSON(str) {
    if (typeof str == 'string') 
    {
        try 
        {
            var obj = JSON.parse(str);
            return true;
        } catch(e)
        {
            return false;
        }
    }
}　

export function sdkRelease(callback) {
    encoderSocket.destroy();
}

export function connectToSdk(object) {
    let socket = new encoderSocket.getInstance();
    let json = JSON.stringify(object);
    socket.send(json);
}

export function connectToSdkWithRSA(object) {
    let socket = new encoderSocket.getInstance();
    let json = JSON.stringify(object);
    //console.log(json);

    // console.log('connectToSdkWithRSA');
    // let socketPublicKey = new NodeRSA(socket.publicKey, 'pkcs1-public-pem');
    // socketPublicKey.setOptions({encryptionScheme: 'pkcs1'});
    // console.log(json);
    // let content = socketPublicKey.encrypt(json, 'base64');
    // console.log(content);
    // socket.send(content);
    socket.send(json);
}

export function initSdk() 
{
    let object = {
        'cmd': 'sdkinit',
        'data': {
            'type':1
        }
    };

    connectToSdk(object);
}


export function registerSdk(id, token, supportkey) 
{
    let object = {
        'cmd': 'registersdk',
        'data': {
            'type':'token',
            'duration': 3600,
            'interfaces':['registerkey','logoutkey','logoutkeywithoutcodes','createregisterkey','createlogoutkey','createblankkey','createemergencykey','createtracekey','readkey', 'readkeyevent', 'readkeyeeprom', 'restartkey', 'writekeyfactorynumber', 'upgradedongle','readdongle','registerdongle','logoutdongle','writedonglelimit','readcardofnewcd','registercardofnewcd','logoutcardofnewcd','createmanagecardofnewcd','createlogoutcardofnewcd','createresetcardofnewcd'],
            'projectid':id,
            'token': token,
            'url': api.BASE_API + '/project/sdk',
            'supportkey': supportkey
        }
    };

    connectToSdkWithRSA(object);
}

export function readCardOfNewCD(beep, registerCode, iv) 
{
    let object = {
        'cmd': 'readcardofnewcd',
        'data': {
            'registercode': registerCode,
            'iv': iv,
            'beep': beep
        }
    };

    connectToSdkWithRSA(object);
}

export function registerCardOfNewCD(cardType, beep, registerCode, iv) 
{
    let object = {
        'cmd': 'registercardofnewcd',
        'data': {
            'cardtype': cardType,
            'beep': beep,
            'registercode': registerCode,
            'iv': iv,
        }
    };

    connectToSdkWithRSA(object);
}

export function logoutCardOfNewCD(cardType, beep, registerCode, iv) 
{
    let object = {
        'cmd': 'logoutcardofnewcd',
        'data': {
            'cardtype': cardType,
            'beep': beep,
            'registercode': registerCode,
            'iv': iv,
        }
    };

    connectToSdkWithRSA(object);
}

export function createManageCardOfNewCD(cardType, userId, logoutCardUserId, regcodeEnable, beginTime, endTime, beep, registerCode, iv) 
{
    let object = {
        'cmd': 'createmanagecardofnewcd',
        'data': {
            'cardtype': cardType,
            'userid': userId,
            'logoutcarduserid': logoutCardUserId,
            'regcodeenable': regcodeEnable,
            'begintime': beginTime,
            'endtime': endTime,
            'beep': beep,
            'registercode': registerCode,
            'iv': iv,
        }
    };

    connectToSdkWithRSA(object);
}

export function createLogoutCardOfNewCD(cardType, userId, manageCardUserId, beginTime, endTime, beep, registerCode, iv) 
{
    let object = {
        'cmd': 'createlogoutcardofnewcd',
        'data': {
            'cardtype': cardType,
            'userid': userId,
            'managecarduserid': manageCardUserId,
            'begintime': beginTime,
            'endtime': endTime,
            'beep': beep,
            'registercode': registerCode,
            'iv': iv,
        }
    };

    connectToSdkWithRSA(object);
}

export function createResetCardOfNewCD(cardType, userId, beginTime, endTime, beep, registerCode, iv) 
{
    let object = {
        'cmd': 'createresetcardofnewcd',
        'data': {
            'cardtype': cardType,
            'userid': userId,
            'begintime': beginTime,
            'endtime': endTime,
            'beep': beep,
            'registercode': registerCode,
            'iv': iv,
        }
    };

    connectToSdkWithRSA(object);
}

export function registerKey(beep) 
{
    let object = {
        'cmd': 'registerkey',
        'data': {
            'beep': beep
        }
    };

    connectToSdkWithRSA(object);
}

export function logoutKey(beep) 
{
    let object = {
        'cmd': 'logoutkey',
        'data': {
            'beep': beep
        }
    };

    connectToSdkWithRSA(object);
}

export function logoutKeyWithoutCodes(beep) 
{
    let object = {
        'cmd': 'logoutkeywithoutcodes',
        'data': {
            'beep': beep
        }
    };

    connectToSdkWithRSA(object);
}

export function createRegisterKey(beep) 
{
    let object = {
        'cmd': 'createregisterkey',
        'data': {
            'id': 1,
            'beep': beep
        }
    };

    connectToSdkWithRSA(object);
}

export function createLogoutKey(beep) 
{
    let object = {
        'cmd': 'createlogoutkey',
        'data': {
            'id': 1,
            'beep': beep
        }
    };

    connectToSdkWithRSA(object);
}

export function createBlankKey(beep)
{
    let object = {
        'cmd': 'createblankkey',
        'data': {
            'id': 1,
            'beep': beep
        }
    };

    connectToSdkWithRSA(object);
}

export function createEmergencyKey(beep, begin, end)
{
    let object = {
        'cmd': 'createemergencykey',
        'data': {
            'id': 1,
            'activationtime': begin,
            'expirytime': end,
            'beep': beep,
        }
    };

    connectToSdkWithRSA(object);
}

export function createTraceKey(beep)
{
    let object = {
        'cmd': 'createtracekey',
        'data': {
            'id': 1,
            'beep': beep
        }
    };

    connectToSdkWithRSA(object);
}

export function readKey(beep) 
{
    let object = {
        'cmd': 'readkey',
        'data': {
            'beep': beep,
            'defaultflag': true
        }
    };

    connectToSdkWithRSA(object);
}

export function readKeyEEPROM(start, length, beep) 
{
    let object = {
        'cmd': 'readkeyeeprom',
        'data': {
            'beep': beep,
            'start': start,
            'length': length,
            'defaultflag': true
        }
    };

    connectToSdkWithRSA(object);
}

export function restartKey(beep) 
{
    let object = {
        'cmd': 'restartkey',
        'data': {
            'beep': beep,
            'defaultflag': true
        }
    };

    connectToSdkWithRSA(object);
}

export function writeKeyFactoryNumber(factoryNumber, beep) 
{
    let object = {
        'cmd': 'writekeyfactorynumber',
        'data': {
            'beep': beep,
            'factorynumber': factoryNumber,
            'force': false,
            'defaultflag': true
        }
    };

    connectToSdkWithRSA(object);
}


export function readKeyEvent(beep) 
{
    let object = {
        'cmd': 'readkeyevent',
        'data': {
            'beep': beep,
            'defaultflag': true
        }
    };

    connectToSdkWithRSA(object);
}

export function upgradeDongle() {
    let object = {
        'cmd': 'upgradedongle',
        'data': {
        }
    };

    connectToSdkWithRSA(object);
}

export function readDongle() {
    let object = {
        'cmd': 'readdongle',
        'data': {
        }
    };

    connectToSdkWithRSA(object);
}

export function registerDongleV1(type, license, publicEncode) {
    let object = {
        'cmd': 'registerdongle',
        'data': {
            'type': type,
            'license': license,
            'public': publicEncode,
            'version': 1
        }
    };

    connectToSdkWithRSA(object);
}

export function registerDongle(type, license, publicEncode, supportkey) {
    let object = {
        'cmd': 'registerdongle',
        'data': {
            'type': type,
            'license': license,
            'public': publicEncode,
            'supportkey': supportkey
        }
    };

    connectToSdkWithRSA(object);
}

export function logoutDongle() {
    let object = {
        'cmd': 'logoutdongle',
        'data': {
        }
    };

    connectToSdkWithRSA(object);
}

export function cleanDongle(mac) {
    let object = {
        'cmd': 'writedonglebind',
        'data': {
            'mac': mac
        }
    };

    connectToSdkWithRSA(object);
}

export function writeDongleLimit(userlimit, locklimit) {
    let object = {
        'cmd': 'writedonglelimit',
        'data': {
            'userlimit': userlimit,
            'locklimit': locklimit
        }
    };

    connectToSdkWithRSA(object);
}



// WEBPACK FOOTER //
// ./src/utils/encoder.js